import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddTravelRequest from "./AddTravelRequest";
import GetAllTravelRequests from "./GetAllTravelRequests";
import { Col, Row, Form } from "antd";
import { useState } from "react";

const Travel = (props) => {
	const [form] = Form.useForm();
	const [isEditMode, setIsEditMode] = useState(false);
	const [currentTravelId, setCurrentTravelId] = useState(null);

	const isLogged = Boolean(localStorage.getItem("isLogged"));
	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div className="add-travel-page-wrapper">
			
			<Row gutter={16} className="add-travel-row">
				{/* Left Side - Add Travel Request Form */}
				<Col xs={24} sm={24} md={10} lg={8} className="add-travel-form-col">
					<AddTravelRequest
						form={form}
						isEditMode={isEditMode}
						setIsEditMode={setIsEditMode}
						currentTravelId={currentTravelId}
						setCurrentTravelId={setCurrentTravelId}
					/>
				</Col>

				{/* Right Side - Travel Requests List */}
				<Col xs={24} sm={24} md={14} lg={16} className="add-travel-table-col">
					<GetAllTravelRequests
						form={form}
						setIsEditMode={setIsEditMode}
						setCurrentTravelId={setCurrentTravelId}
					/>
				</Col>
			</Row>
		</div>
	);
};

export default Travel;

